$(document).ready(function(){

 $('.header__active-menu-item').parent().addClass('menuactive')


/*Banner Play/Pause button*/
var clicked_id;
var audio_var;

$('#ppbutton1').on("click",function(){
  var datasrc = $(this).attr('data-src');
  clicked_id= $(this).attr('id');
  console.log(clicked_id);
  if($(this).hasClass('fa-play')){
     console.log('play_click');
     audio_var = new Audio(datasrc);
     $(this).removeClass('fa-play');
     $(this).addClass('fa-pause');
     console.log(audio_var);
     audio_var.play();
   } else {
     console.log('pause_click');
     $(this).removeClass('fa-pause');
     $(this).addClass('fa-play');
     console.log(audio_var);
     audio_var.pause();
     //audio_var.src='';
     //audio_var.load();
   console.log(audio_var);
   }
});
  /*Collection List Slick Slider*/
var wwidth= $(window).width();
// call the function...

loadScript('https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js', function() { $('#cstumcollectionlist-slider').slick({
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  dots: false,
  centerMode: true,
  variableWidth: true,
  infinite: true,
  speed: 300,
  focusOnSelect: true,
  cssEase: 'linear',
  touchMove: true,
prevArrow: '<button class="slick-prev slick-arrow fa fa-arrow-left slickhide" aria-hidden="true"></button>',
nextArrow: '<button class="slick-next slick-arrow fa fa-arrow-right slickhide" aria-hidden="true"></button>'
// responsive: [
//     {
//       breakpoint: 767,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: true,
//         variableWidth: true
//       }
//     }
//   ]
});
});
/*Product Play/Pause button*/

var audios = document.querySelectorAll('audio');
for(var i=0; i < audios.length; i++)
   audios[i].addEventListener('play', function(){pauseAll(this)}, true); 

/*append product audio data to ffoter div*/



$('.prodbtn').on("click",function(){
  var crntbtn = $(this).attr('data-id');
  var dataprice = $(this).attr('data-price');
 if(crntbtn == 'true' || dataprice == 0){
  $('.btmplaycstminr .btmbuy').css('display','none');
 }else{
     $('.btmplaycstminr .btmbuy').css('display','block');
 }
  $('.btmplaycstm').removeClass('hidebtm');

  var cpdata = $(this).parent().parent().siblings('.card__information');

  var prodtit = cpdata.find('.prod-titlec').text();
  var produrl = cpdata.find('a').attr('href');
  $('.btmplaycstminr .prod-title').text(prodtit);
  $('.btmbuy a').attr("href",produrl);
   var pdatasrc = $(this).attr('data-src');
 
  $('.btmmyaudio').attr("src",pdatasrc)[0];
  
   $('.btmmyaudio').trigger('play');

  
});

$('.close-icon').on("click",function(){
  $('.btmplaycstm').addClass('hidebtm');
  $('.footer-wr').addClass('btmmarign');
  $('.btmmyaudio').trigger('pause');
});


  
  
});
function pauseAll(elem){
  var audios = document.querySelectorAll('audio');
  		var x = document.getElementsByClassName("pauseicon");
	for(var i=0; i<audios.length; i++){
		//Is this the one we want to play?
		if(audios[i] == elem) continue;
		//Have we already played it && is it already paused?
		if(audios[i].played.length > 0 && !audios[i].paused){
		// Then pause it now
		  audios[i].pause();
         audios[i].parentNode.classList.add("pauseicon");
         
          
		}
      
	}
  }



window.addEventListener("globoFilterRenderCompleted",function(e){  


$('.prodbtn').on("click",function(){
  $('.btmplaycstm').removeClass('hidebtm');
  var cpdata = $(this).parent().parent().siblings('.card__information');

  var prodtit = cpdata.find('.prod-titlec').text();
  var produrl = cpdata.find('a').attr('href');
  $('.btmplaycstminr .prod-title').text(prodtit);
  $('.btmbuy a').attr("href",produrl);
   var pdatasrc = $(this).attr('data-src');
  $('.btmmyaudio').attr("src",pdatasrc)[0];
 
   $('.btmmyaudio').trigger('play');
  
});
  
})


/*Audio Preview Play*/
$(document).ready(function(){
var clicked_id1;
var audio_var1;

$('.prevbtn').on("click",function(){
    var datasrc = $(this).attr('data-src');
  clicked_id1= $(this).attr('id');
  // console.log(clicked_id1);
  // $('.prevbtn').each(function(){
  //   console.log('play_click');
  //    audio_var1 = new Audio(datasrc);
  //    $('.prevbtn').toggleClass('fa-pause');
  //    $('.prevbtn').toggleClass('fa-play');
  //    console.log(audio_var1);
  //    audio_var1.pause();
  //   });
  if($(this).hasClass('fa-play')){
     console.log('play_click');
     audio_var1 = new Audio(datasrc);
     $(this).toggleClass('fa-play');
     $(this).toggleClass('fa-pause');
     console.log(audio_var1);
     audio_var1.play();
   } 
else {
     console.log('pause_click');
     $(this).toggleClass('fa-pause');
     $(this).toggleClass('fa-play');
     console.log(audio_var1);
     audio_var1.pause();
     //audio_var.src='';
     //audio_var.load();
   console.log(audio_var1);
   }
});

/*Icon manage on collection Page*/
$('.iconsection li.mediumicon').click(function(){
  $(this).addClass('iconshow');
  $('.iconsection li.largeicon').removeClass('iconshow');
  $('.collection ul.product-grid').addClass('grid--6-col-desktop');
  $('.collection ul.product-grid').removeClass('grid--4-col-desktop');
});
  $('.iconsection li.largeicon').click(function(){
  $(this).addClass('iconshow');
  $('.iconsection li.mediumicon').removeClass('iconshow');
  $('.collection ul.product-grid').addClass('grid--4-col-desktop');
  $('.collection ul.product-grid').removeClass('grid--6-col-desktop');
});

  var wrwidth= $(window).width();
if(wrwidth<768){
$(".cstm-filter").click(function(){
  $(this).children("ul").slideToggle("slow");
  $(this).toggleClass("upicon");
});
}


  
  
});

function loadScript( url, callback ) {
  var script = document.createElement( "script" )
  script.type = "text/javascript";
  if(script.readyState) {  // only required for IE <9
    script.onreadystatechange = function() {
      if ( script.readyState === "loaded" || script.readyState === "complete" ) {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {  //Others
    script.onload = function() {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName( "head" )[0].appendChild( script );
}
// var vid = document.getElementById("audivolbx");
// vid.volume = 0.2;
/*SubMenu*/
$(document).ready(function(){
  $('.menuactive').parent().attr('open','open');
});